<template>
  <div v-if="props.show" class="date-range-picker" ref="pickerRef">
    <DatePicker
        v-model.range="dates"
        :attributes="attributes"
        :is-range="props.range"
        :popover="false"
        :show-caps="false"
        :title-position="'left'"
        :locale="'ru'"
        :min-date="null"
        :max-date="null"
    />

    <div class="btn">
      <VButtonNew class="w-full" label="Отмена" style-type="grey" @click.stop="cancel" />
      <VButtonNew class="w-full" label="Ок" @click.stop="ok" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({ start: null, end: null }),
  },
  range: {
    type: Boolean,
    default: true,
  },
  show: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'updateShow']);

// Реактивная модель выбранных дат
const dates = ref({
  start: props.modelValue.start ? new Date(props.modelValue.start) : null,
  end: props.modelValue.end ? new Date(props.modelValue.end) : null,
});

// Атрибуты для визуального выделения
const attributes = ref([
  {
    key: 'selected',
    highlight: {
      fillMode: 'light',
      contentClass: 'bg-blue-100',
    },
    dates,
  },
]);

// Обновление внешнего значения после нажатия "ОК"
const ok = () => {
  emit('update:modelValue', {
    start: dates.value.start,
    end: dates.value.end,
  });
  emit('updateShow', false);
};

// Отмена выбора
const cancel = () => {
  emit('updateShow', false);
};

// Отслеживаем изменения внешней модели
watch(
    () => props.modelValue,
    (newVal) => {
      dates.value = {
        start: newVal.start ? new Date(newVal.start) : null,
        end: newVal.end ? new Date(newVal.end) : null,
      };
    }
);

// Закрытие при клике вне компонента
const pickerRef = ref(null);

const handleClickOutside = (event) => {
  if (pickerRef.value && !pickerRef.value.contains(event.target)) {
    emit('updateShow', false);
  }
};

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside);
});
</script>

<style scoped lang="scss">
.date-range-picker {
  position: absolute;
  top: 50px;
  left: 0;
  //width: 320px;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;

  .btn {
    display: flex;
    gap: 8px;
    margin-top: 12px;
  }
}
/* Стиль для выбранной даты */
:deep(.vc-highlight) {
  background-color: $primary-main !important;
}

/* Стиль для ховера на любой день */
:deep(.vc-day-content:hover) {
  background-color: $primary-hover !important;
}
</style>
